<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="dark-green"
      d="M13.8508 12L16.1903 14.6742L19.3366 16.6845L19.8839 12.0168L19.3366 7.45442L16.1301 9.22046L13.8508 12Z"
      fill="none"
    />
    <path
      class="dark-blue"
      d="M0.273605 16.2502V20.2278C0.273605 21.1359 1.01081 21.8733 1.91919 21.8733H5.89673L6.72037 18.8679L5.89673 16.2502L3.16785 15.4266L0.273699 16.2502H0.273605Z"
      fill="none"
    />
    <path
      class="red"
      d="M5.89673 2.12666L0.273605 7.74979L3.16803 8.57145L5.89673 7.74979L6.70537 5.16762L5.89673 2.12666Z"
      fill="none"
    />
    <path
      class="blue"
      d="M0.273605 16.2517H5.89673V7.74934H0.273699L0.273605 16.2517Z"
      fill="none"
    />
    <path
      class="green"
      d="M22.929 4.5076L19.3369 7.45452V16.6845L22.9438 19.6429C23.4838 20.0659 24.2736 19.6804 24.2736 18.994V5.14337C24.2736 4.44938 23.4649 4.06578 22.9289 4.50769"
      fill="none"
    />
    <path
      class="green"
      d="M13.8493 12V16.2502H5.89629V21.8734H17.6897C18.598 21.8734 19.3351 21.1359 19.3351 20.2278V16.6846L13.8493 12Z"
      fill="none"
    />
    <path
      class="yellow"
      d="M17.6897 2.12666H5.89629V7.74979H13.8493V11.9999L19.3352 7.45431V3.77233C19.3352 2.86396 18.598 2.12676 17.6897 2.12676"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "GMeetIcon",
});
</script>

<style scoped lang="scss">
@use "./google.scss";
</style>
